import * as React from "react";
import {TitleProgress} from "./TitleProgress";
import {SolarSelectionStep} from "./steps/solar-selection-step";
import {BatterySelectionStep} from "./steps/battery-selection-step";
import {OrderStep} from "./steps/order-step";
import {ConfirmationStep} from "./steps/confirmation-step";
import {useLeadStore} from "./store/Lead.store";
import {observer} from "mobx-react-lite";
import {LeadGenerationStep} from "./services/types/lead-generation-step";
import {OrderTypeSelectionStep} from "./steps/order-type-selection-step";
import {ConfirmationNewConstructionStep} from "./steps/confirmation-new-construction-step";

const MAX_STEPS = 3;

interface StepComponentProps
{
    title: string;
    currentStep: number;
    maxSteps: number;
    children?: React.ReactNode;
}

const StepComponent = observer( ( props: StepComponentProps ) => {
    const store = useLeadStore();
    return <React.Fragment>
        <TitleProgress title={store.translate( props.title )} currentStep={props.currentStep} maxSteps={props.maxSteps}/>
        {props.children}
    </React.Fragment>;
} );

export const LeadsStep = observer( () => {
    const store = useLeadStore();

    if ( !store.initialized ) {
        return (<React.Fragment/>);
    }

    switch ( store.currentStep ) {
        case LeadGenerationStep.ORDER_TYPE:
            return <StepComponent title={'leadgeneration.steps.orderTypeSelection.stepTitle'}
                                  currentStep={1}
                                  maxSteps={MAX_STEPS}>
                <OrderTypeSelectionStep/>
            </StepComponent>;
        case LeadGenerationStep.SOLAR_BATTERY:
            return <StepComponent title={'leadgeneration.steps.solarSelectionStep.stepTitle'}
                                  currentStep={2}
                                  maxSteps={MAX_STEPS}>
                <SolarSelectionStep/>
            </StepComponent>;
        case LeadGenerationStep.BATTERY:
            return <StepComponent title={'leadgeneration.steps.batterySelectionStep.stepTitle'}
                                  currentStep={2}
                                  maxSteps={MAX_STEPS}>
                <BatterySelectionStep/>
            </StepComponent>;
        case LeadGenerationStep.ORDER:
            return <StepComponent title={'leadgeneration.steps.orderStep.stepTitle'}
                                  currentStep={3}
                                  maxSteps={MAX_STEPS}>
                <OrderStep/>
            </StepComponent>;
        case LeadGenerationStep.CREATE_APPOINTMENT:
            return <StepComponent title={'leadgeneration.steps.createAppointmentStep.stepTitle'}
                                  currentStep={3}
                                  maxSteps={MAX_STEPS}>
                <ConfirmationStep/>
            </StepComponent>;
        case LeadGenerationStep.ORDER_CONFIRMATION:
            return <StepComponent title={'leadgeneration.steps.confirmationStep.stepTitle'}
                                  currentStep={3}
                                  maxSteps={MAX_STEPS}>
                <ConfirmationStep/>
            </StepComponent>;
        case LeadGenerationStep.CONFIRMATION_NEW_CONSTRUCTION:
            return <StepComponent title={'leadgeneration.steps.confirmationNewConstructionStep.stepTitle'}
                                  currentStep={2}
                                  maxSteps={2}>
                <ConfirmationNewConstructionStep/>
            </StepComponent>;
    }

    return <React.Fragment/>;
} );
